import { Container, Grid, Tab, Tabs } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { IFormFieldKeyList } from "../../../_common/models/formFieldKey";
import { IFormTemplateSectionManage } from "../../../_common/models/formTemplateSection";
import { toastr } from "../../../_components/toastr/toastr";
import { formFieldKeyService } from "../../../_services/formFieldKey.service";
import { formTemplateSectionService } from "../../../_services/formTemplateSection.service";
import { FormFieldKeyList } from "../FormFieldKey/formFieldKey-list";
import { FormFieldKeyManageDrawer } from "../FormFieldKey/formFieldKey-manageDrawer";
import { FormTemplateSectionList } from "./formTemplateSection-list";
import { FormTemplateSectionManage } from "./formTemplateSection-manage";
import { FormFieldKeyLookupList } from "../formFieldKeyLookup/formFieldKeyLookup-list";
import { FormFieldKeyLookupManage } from "../formFieldKeyLookup/formFieldKeyLookup-manage";
import { FormFieldValueTypeEnum } from "../../../_common/enum/forms/formFieldValueType.enum";
import { FormSectionManage } from "../../../form/formSection/formSection-manage";

export function FormTemplateSectionView() {
    const editorRef = useRef(null);

    let navigate = useNavigate();

    const [data, setData] = useState<IFormTemplateSectionManage>({ formHtml: "" } as IFormTemplateSectionManage);
    const [fieldKeys, setFieldKeys] = useState<Array<IFormFieldKeyList>>([]);
    const [tabValue, setTabValue] = useState(0);

    const [isLoading, setLoading] = useState(false);
    const [count, setCount] = useState(0);
    const [isDirty, setIsDirty] = useState(false);
    const [areFormFieldKeysLoading, setAreFormFieldKeysLoading] = useState(true);

    const { formTemplateSectionId } = useParams<{ formTemplateSectionId: string }>();
    const _formTemplateSectionId = Number(formTemplateSectionId);
    const tinyMceSettings = {
        height: 500,
        menubar: true,
        plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code table',
            'insertdatetime media '
        ],
        table_appearance_options: true,
        toolbar: 'mybutton ',
        statusbar: true
    };
    const [settings, setSettings] = useState(tinyMceSettings);

    useEffect(() => {
        fetchData();
        fetchFieldKeys();
    }, []);

    useEffect(() => {
        setSettings(tinyMceSettings);
    }, [fieldKeys]);

    function fetchData() {
        setLoading(true);
        return formTemplateSectionService
            .get(+(formTemplateSectionId || 0))
            .then(
                (json) => {
                    setData(json);
                }
            )
            .finally(() => setLoading(false));
    }

    function fetchFieldKeys() {
        setAreFormFieldKeysLoading(true);
        setCount((count + 1))
        return formFieldKeyService
            .getAll(+(formTemplateSectionId || 0))
            .then(
                (json) => {
                    setFieldKeys(json)
                }
            )
            .finally(() => setAreFormFieldKeysLoading(false));
    }

    function submit() {
        setLoading(true);

        let _data = { ...data };
        // _data.formHtml = editorRef.current.getContent();

        return formTemplateSectionService
            .updateForm(_data)
            .then(
                (json) => {
                    toastr.success("Saved Successfully");
                    setIsDirty(false);
                }
            )
            .finally(() => setLoading(false));
    }


    return (
        <>
            <Container component="main">

                <Tabs value={tabValue} onChange={(e, newValue) => { setTabValue(newValue) }} aria-label="simple tabs example">
                    <Tab label="Form Field Keys" />
                    <Tab label="Preview" />
                </Tabs>


                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {tabValue == 0 &&
                            <FormFieldKeyList count={count} editorRef={editorRef} />
                        }
                        {tabValue == 1 &&
                            <FormSectionManage
                                formTemplateSectionId={_formTemplateSectionId}
                                isForReview
                                isSectionSaving={false}
                                formSectionId={0}
                                onSave={() => { }} />
                        }
                    </Grid>
                </Grid>


                <Routes>

                    <Route path="/CreateFormFieldKey" element={<FormFieldKeyManageDrawer emitOnSave={() => { setCount(count + 1) }} emitOnClose={() => { navigate(""); }} />} />

                    <Route path="/EditFormFieldKey/:formFieldKeyId/" element={<FormFieldKeyManageDrawer emitOnSave={() => { setCount(count + 1) }} emitOnClose={() => { navigate(""); }} />} >
                        <Route path="CreateFormFieldKeyLookup" element={<FormFieldKeyLookupManage emitOnSave={() => { }} emitOnDelete={() => { }} />} />
                        <Route path="EditFormFieldKeyLookup/:formFieldKeyLookupId" element={<FormFieldKeyLookupManage emitOnSave={() => { }} emitOnDelete={() => { }} />} />
                        <Route path="" element={<FormFieldKeyLookupList />} />
                    </Route>

                </Routes>
            </Container>


        </>
    );
}